export const PORTFOLIO_PROJECTS = [
	{
		id: "knight-games",
		name: "Knight Games",
		path: "/portfolio/knight-games",
		hide: false,
		image: "/thumbnails/knight-games-thumbnail.png",
		bgImage: "/backgrounds/knight-games-background.jpg",
		tags: ["Full Game", "2025"],
		links: [
			{ href: "https://store.steampowered.com/app/3752150/Knight_Games/", external: true },
			{ href: "https://discord.gg/evCXwSt", external: true }
		],
		description: "A place to play night games and knight games with your friends. It'll include games like capture the flag, jousting, and an obstacle course. There will also be exploration elements to unlock minigames, and support at least a dozen players.",
		buzzwords: ["C#", "Unity Engine", "Game Design", "3D Physics", "Netcode for GameObjects", "Unity Relay", "Online Multiplayer", "Local Multiplayer", "Playtesting"],
		contribution: [
			"I'm the lead developer for Knight Games, personally building approximately 90% of the game's mechanics & architecture. This includes building foundational systems such as player movement, real-time networking, user interfaces, and the logic for various minigames.",
			"Beyond development, I manage the crucial steps of iterative design: regularly running playtests, gathering and prioritizing user feedback, and actively translating those insights into actionable features.",
			"To maintain a clear project vision, I also author detailed game design documentation outlining our key player experience decisions. Finally, I handle all visual assets required for public presentation, including the logo design and the creation of all required Steam store assets.",
		],
	},
	{
		id: "errand-task-force",
		name: "Errand Task Force",
		path: "/portfolio/errand-task-force",
		hide: false,
		image: "/thumbnails/errand-task-force-thumbnail.jpg",
		bgImage: "/backgrounds/errand-task-force-background.png",
		tags: ["Full Game", "2024"],
		links: [
			{ href: "https://store.steampowered.com/app/3053830/Errand_Task_Force/", external: true },
			{ href: "https://discord.gg/evCXwSt", external: true }
		],
		description: "A 4-player co-op game about running errands and planning the best route in order to beat the clock. Players must work together to complete tasks efficiently while navigating an ever-changing city map.",
		buzzwords: ["C#", "Unity Engine", "Game Design", "Level Design", "Playtesting", "Pitch Deck Design", "Local Multiplayer"],
		contribution: [
			"I contribute significantly to both the technical development and the core strategic vision, building and implementing foundational game mechanics. I excel in collaborative game design work, where I actively participate in designing and refining mechanics, a process that has dramatically shaped Errand Task Force since the beginning.",
			"In order to validate our decisions, I facilitate in-person playtests, gathering essential feedback and continually simplifying the player experience based on these sessions. I've also applied my strategic communication skills by writing a comprehensive pitch deck used to seek publisher funding for Errand Task Force.",
		],
	},
	{
		id: "globalsim-cloud",
		name: "GlobalSim Cloud",
		path: "/portfolio/globalsim-cloud",
		hide: false,
		image: "/thumbnails/globalsim-cloud-thumbnail.jpg",
		bgImage: "/backgrounds/globalsim-cloud-background.jpg",
		companyName: "GlobalSim, Inc",
		tags: ["Work Project", "2023"],
		links: [
			{ label: "globalsim.com", href: "https://www.globalsim.com/cloud", external: true }
		],
		description: "A cloud-delivered simulation platform for training operators of cranes and other heavy machinery, including port, construction, and industrial equipment. The Cloud platform represents a subset of GlobalSim's simulation systems, which had to be adapted for cloud delivery.",
		buzzwords: ["C#", "Unity Engine", "Cloud Content Delivery", "Software Architecture", "Refactoring", "Optimization"],
		contribution: [
			"GlobalSim's flagship offering are large, full-mission simulation stations. GlobalSim Cloud was created to extend this offering to laptops and other hardware that many clients aready use. I created a launcher app to download software over-the-air, and optimized the simulation to run on lower-end hardware, ensuring a seamless user experience across different devices.",
			"I played a major role in the architecture and rewrite of input logic to handle keyboards and gamepads (instead of custom hardware interfaces), which was one of the main challenges in creating GlobalSim Cloud. This included dozens of individual input mappings and configurations to ensure compatibility with a wide range of devices.",
		],
	},
	{
		id: "ore3d",
		name: "Ore3D",
		hide: false,
		path: "/portfolio/ore3d",
		image: "/thumbnails/ore3d-thumbnail.jpg",
		bgImage: "/backgrounds/ore3d-background.jpg",
		companyName: "Ore Design",
		tags: ["Work Project", "2022"],
		links: [
			{ label: "ore.design", href: "https://ore.design/", external: true }
		],
		description: "Ore3D is a replacement system for legacy sales and estimating software. It includes no-fluff BOM calculation and a completely new 3D visualization tool that wasn't present in the previous system.",
		buzzwords: ["C#", "Unity Engine", "Requirements Gathering", "Solo Development", "3D Modeling"],
		contribution: [
			"I was promoted at Ore Design to be the Business System Administrator over the sales estimating tool at the time, called Experlogix. This system was difficult to maintain and a bit dated, so I designed Ore3D from the ground up as a modern replacement and spearheaded its development.",
			"My contributions included gathering requirements from stakeholders, designing software architecture, and implementing the entire system as a solo developer. The 3D visualization tool within Ore3D allowed users to see a real-time preview of their custom product as they configured it, which was completely absent from the previous Experlogix system.",
		],
	},
	{
		id: "atmospheric",
		name: "Atmospheric",
		path: "/portfolio/atmospheric",
		hide: false,
		image: "/thumbnails/atmospheric-thumbnail.png",
		bgImage: "/backgrounds/atmospheric-background.jpg",
		tags: ["Game Jam", "2024"],
		links: [
			{ href: "https://sora1337.itch.io/atmospheric", external: true }
		],
		description: "An incremental game about planting seeds on a planet to restore its atmosphere. Unlock new plants as the atmosphere improves, and discover what seeds can be planted in different environments. Completed in 26 development hours over a weekend.",
		buzzwords: ["26 Hours", "C#", "Unity Engine", "Solo Development", "Mechanics Design"],
	},
	{
		id: "sqwordle-national",
		name: "Sqwordle National",
		path: "/portfolio/sqwordle-national",
		hide: false,
		image: "/thumbnails/sqwordle-national-thumbnail.jpg",
		bgImage: "/backgrounds/sqwordle-national-background.png",
		tags: ["Prototype", "2023"],
		links: [
			{ href: "https://anonlineuser.itch.io/sqwordle-national", external: true }
		],
		description: "A recreation and expansion of Sqwordle, a Wordle-like game. Choose Pokémon from the National Pokédex to guess which one the game is thinking of. Use hints like the Pokémon's type, generation, and base stats to narrow down your guesses.",
		buzzwords: ["C#", "Unity Engine", "REST API Integration", "Solo Development", "Unity UI"],
	},
	{
		id: "critical-mass",
		name: "Critical Mass",
		path: "/portfolio/critical-mass",
		hide: false,
		image: "/thumbnails/critical-mass-thumbnail.jpg",
		bgImage: "/backgrounds/critical-mass-background.png",
		tags: ["Game Jam", "2021"],
		links: [
			{ href: "https://anonlineuser.itch.io/critical-mass", external: true }
		],
		description: "A 2D, level-based game where you play as a planet that can change its mass. Use this ability to influence the orbits of asteroids and deliver your spacestation to the destination. Completed in 18 development hours over a weekend.",
		buzzwords: ["18 Hours", "C#", "Unity Engine", "Level Design", "Solo Development", "2D Physics"],
		contribution: [
			"I spent a total of 18 development hours over the course of a weekend building Critical Mass for a game jam. This was a completely solo effort, from concept to completion. My focus for this game jam was to limit scope and deliver a polished experience that is easy to understand, rather than something ambitious and unintuitive.",
		],
	},
	{
		id: "subsystem",
		name: "SubSystem",
		path: "/portfolio/subsystem",
		hide: true,
		image: "/thumbnails/subsystem-thumbnail.png",
		bgImage: "/backgrounds/subsystem-background.jpg",
		tags: ["Prototype", "2019"],
		description: "",
	},
	{
		id: "roanoke",
		name: "Roanoke",
		path: "/portfolio/roanoke",
		hide: true,
		image: "/thumbnails/roanoke-thumbnail.png",
		tags: ["Game Jam", "2019"],
		description: "",
	},
	{
		id: "snakey-cord",
		name: "Snakey Cord",
		path: "/portfolio/snakey-cord",
		hide: true,
		image: "/thumbnails/snakey-cord-thumbnail.png",
		tags: ["Game Jam", "2019"],
		links: [
			{ href: "https://anonlineuser.itch.io/snakey-cord", external: true }
		],
	},
	{
		id: "lag-knight-classic",
		name: "Lag Knight (Classic)",
		path: "/portfolio/lag-knight-classic",
		hide: true,
		image: "/thumbnails/lag-knight-classic-thumbnail.jpg",
		tags: ["Game Jam", "2018"],
		description: "",
	},
	{
		id: "citizens-guide-to-ravnica",
		name: "Citizen's Guide to Ravnica",
		path: "/portfolio/citizens-guide-to-ravnica",
		hide: true,
		image: "/thumbnails/citizens-guide-thumbnail.jpg",
		tags: ["Prototype", "2025"],
		links: [
			{ label: "Open the guide", href: "/citizens-guide-to-ravnica" }
		],
	},
	{
		id: "character-sheet",
		name: "Character Sheet",
		path: "/portfolio/character-sheet",
		hide: true,
		image: "Tabletop Tools Thumbnail.jpg",
		tags: ["Tabletop Tool", "2023"],
		links: [
			{ label: "Open Character Sheet", href: "/character-sheet" }
		],
	},
	{
		id: "tabletop-tools",
		name: "Tabletop Tools",
		path: "/portfolio/tabletop-tools",
		hide: true,
		image: "Tabletop Tools Thumbnail.jpg",
		tags: ["Tabletop Tool", "2023"],
	},
	{
		id: "champion-mastery",
		name: "Champion Mastery",
		path: "/portfolio/champion-mastery",
		hide: true,
		image: "/thumbnails/champion-mastery-thumbnail.jpg",
		bgImage: "/backgrounds/champion-mastery-background.jpg",
		companyName: "Riot Games",
		tags: ["Prototype", "2024"],
		links: [
			{ label: "Open Tool", href: "/champion-mastery" }
		]
	}
];

export function getProjectById(id) {
	return PORTFOLIO_PROJECTS.find(p => p.id === id);
}

export function getProjectByPath(path) {
	return PORTFOLIO_PROJECTS.find(p => p.path === path);
}

export function getVisibleProjects() {
	return PORTFOLIO_PROJECTS.filter(p => !p.hide);
}
